import { createAction } from 'redux-actions'

const prefix = 'HOME/'

export const setSelectedTab = createAction(`${prefix}SET_SELECTED_TAB`)

export const openFeatureModalDialog = createAction(`${prefix}OPEN_FEATURE_MODAL_DIALOG`)
export const closeFeatureModalDialog = createAction(`${prefix}CLOSE_FEATURE_MODAL_DIALOG`)
